import * as yup from 'yup'

export const ValidationSchema = {
  agricultor: yup.string().required('Campo é obrigatório'),
  area_consultada: yup.string().matches(/^\d+$/, 'Campo Incorreto').required('Campo é obrigatório'),
  fonte: yup.string().required('Campo é obrigatório'),
  cultura: yup.array().min(1, 'Campo é obrigatório').required('Campo é obrigatório'),
}
